module.exports = __webpack_public_path__ + "static/img/103040.72329ed3.png";